import { render, staticRenderFns } from "./SimpleKeyboard.vue?vue&type=template&id=be3600be&scoped=true&"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleKeyboard.vue?vue&type=style&index=0&id=be3600be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3600be",
  null
  
)

export default component.exports